import { BaseModel } from './base-model';
import { Company } from './company';

export class User extends BaseModel {
  public id: string;
  public username: string;
  public password: string;
  public name: string;
  public email: string;
  public active: boolean;
  public alterPassword: boolean;
  public permissions: Array<PermissionUserCompany>;
  public companies: Array<Company>;
  public typeUser?: ETypeUser;
  public userAcceptanceTerm?: UserAcceptanceTermDto;

  constructor() {
    super();
    this.username = null;
    this.password = null;
    this.name = null;
    this.email = null;
    this.active = true;
    this.alterPassword = false;
    this.permissions = new Array<PermissionUserCompany>();
    this.companies = new Array<Company>();
    this.typeUser = ETypeUser.FINAL_USER;
    this.userAcceptanceTerm = null;
  }
}

export class PermissionUserCompany {
  public type: TypePermissionEnum;
  public companyId: string;
  public powerStep: PowerStep;

  constructor() {
    this.type = TypePermissionEnum.ANALISTA;
    this.companyId = null;
    this.powerStep = null;
  }
}

export class UserAcceptanceTermDto {
  public acceptedTermId?: string;
  public dateTermAcceptance?: Date;

  constructor(acceptedTermId?: string, dateTermAcceptance?: Date) {
    this.acceptedTermId = acceptedTermId;
    this.dateTermAcceptance = dateTermAcceptance;
  }
}

export enum TypePermissionEnum {
  ANALISTA,
  GERENTE_ADMINISTRATIVO,
  GERENTE_LOJA,
  CORPORATIVO,
  DIRETOR_COMERCIAL,
  DIRETOR_PRESIDENTE,
  VISUALIZAR,
}

export class PowerStep {
  public value: number;
  public acceptance: number;

  constructor() {
    this.value = 0;
    this.acceptance = 0;
  }
}

export class ProfileUser extends BaseModel {
  public id: string;
  public description: string;
  public users: Array<string>;
  public permissions: Array<string>;

  constructor() {
    super();
    this.id = null;
    this.description = null;
    this.users = new Array<string>();
    this.permissions = new Array<string>();
  }
}

export class ChangePermission extends BaseModel {
  public user: User;
  public company: Company;
  public startDate: Date;
  public endDate: Date;
  public active: boolean;

  constructor() {
    super();
    this.user = null;
    this.company = null;
    this.startDate = null;
    this.endDate = null;
    this.active = true;
  }
}

export enum ETypeUser {
  SYS_USER,
  FINAL_USER,
}
